<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { AloDbRole } from '@/models/alodb/AloDbRole'

@Component({
  name: 'AdminRoleList'
})

export default class AdminRoleList extends AdminList<AloDbRole> {  
 
  get itemTypeName() {
    return "Role"
  }

}
</script>